export const FETCH_BID_GROUP_DATA_LOADING = 'FETCH_BID_GROUP_DATA_LOADING';
export const SET_BID_GROUP_DATA = 'FETCH_BID_GROUP_DATA';
export const FETCH_BID_GROUP_DATA_LOADING_ERROR =
  'FETCH_BID_GROUP_DATA_LOADING_ERROR';
export const FETCH_ITEM_GROUP_DATA_LOADING = 'FETCH_ITEM_GROUP_DATA_LOADING';
export const SET_ITEM_GROUP_DATA = 'ITEM_GROUP_DATA';
export const FETCH_ITEM_GROUP_DATA_LOADING_ERROR =
  'FETCH_ITEM_GROUP_DATA_LOADING_ERROR';
export const FETCH_ACCT_CATEGORY_DATA_LOADING =
  'FETCH_ACCT_CATEGORY_DATA_LOADING';
export const SET_ACCT_CATEGORY_DATA = 'ACCT_CATEGORY_DATA';
export const FETCH_ACCT_CATEGORY_DATA_LOADING_ERROR =
  'FETCH_ACCT_CATEGORY_DATA_LOADING_ERROR';
export const FETCH_VENDOR_DATA_LOADING = 'FETCH_VENDOR_DATA_LOADING';
export const SET_VENDOR_DATA = 'FETCH_VENDOR_DATA';
export const FETCH_VENDOR_DATA_LOADING_ERROR =
  'FETCH_VENDOR_DATA_LOADING_ERROR';
export const FETCH_STORAGE_LOCATION_DATA_LOADING =
  'FETCH_STORAGE_LOCATION_DATA_LOADING';
export const SET_STORAGE_LOCATION_DATA = 'SET_STORAGE_LOCATION_DATA';
export const FETCH_STORAGE_LOCATION_DATA_LOADING_ERROR =
  'FETCH_STORAGE_LOCATION_DATA_LOADING_ERROR';
export const CLEAR_ERROR_MSG = 'CLEAR_ERROR_MSG';
export const SET_SITE_GROUP_DATA = 'SET_SITE_GROUP_DATA';
export const FETCH_SITE_GROUP_DATA = 'FETCH_SET_SITE_GROUP_DATA';
export const FETCH_SITE_GROUP_DATA_ERROR = 'FETCH_SET_SITE_GROUP_DATA_ERROR';



// WEBPACK FOOTER //
// ./src/state/filters/types.js